import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ factoryAreaParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `FactoryArea/GetSearched`,
      params: factoryAreaParams,
    });
    const allFactoryArea = data;
    yield put(Actions.setAll({ allFactoryArea }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllFactoryAreas() {
  try {
    const { data } = yield call(api.get, {
      route: `FactoryArea`,
    });
    const allFactoryArea = data;
    yield put(Actions.setAll({ allFactoryArea }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateFactoryArea({ factoryAreaData, actionName, factoryAreaParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `FactoryArea`,
      data: factoryAreaData,
    });
    yield put(Actions.fetchAll({ factoryAreaParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.FACTORY_AREA_CREATED
        : CONSTANT_VARIABLES.FACTORY_AREA_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteFactoryArea({ id, factoryAreaParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `FactoryArea/${id}`,
    });
    yield put(Actions.fetchAll({ factoryAreaParams }));
    notification('success', CONSTANT_VARIABLES.FACTORY_AREA_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_ALL_FACTORY_AREAS, fetchAllFactoryAreas),
    takeLatest(ActionTypes.ADD_OR_UPDATE_FACTORY_AREA, addorUpdateFactoryArea),
    takeLatest(ActionTypes.DELETE_FACTORY_AREA, deleteFactoryArea),
  ]);
}
